'use client';

import { usePathname, useRouter } from 'next/navigation';
import { type ReactNode, useEffect, type FC } from 'react';
import { ChevronLeft } from '@eqi-investimentos/icons/web';
import { Flex, Text, IconButton } from '@eqi-investimentos/react';
import { PATHS } from '@/config/paths';
import { monetaryButtonHeaderScreensRoutes } from '@/config/routesConfig';
import { Thumb } from '@/components/atoms/Thumb';
import useHeaderViewModel from '@/viewModels/HeaderViewModel/HeaderViewModel';
import { IfRender } from '@/utils/jsx';
import { MonetaryVisibilityButton } from '../MonetaryVisibilityButton';
import { RightActions } from './components/RightActions';
export const Header: FC<HeaderProps> = ({
  title,
  rightChildren = <></>,
  showLogo = false
}) => {
  const router = useRouter();
  const pathname = usePathname();
  const checkHistory = () => {
    if (typeof window !== 'undefined') {
      return window.history.length;
    }
    return 0;
  };
  const {
    greetings
  } = useHeaderViewModel();
  useEffect(() => {
    window.dispatchEvent(new Event('recheck-monetary-visibility'));
  }, [pathname]);
  const handleNavigateBack = () => {
    if (checkHistory() <= 2) {
      router.push(PATHS.home);
      return;
    }
    router.back();
  };
  return <Flex justifyContent="space-between" alignItems="center" p="2xl" w="full" borderBottomWidth="1px" borderBottomColor="border.secondary" color="content.primary" data-sentry-element="Flex" data-sentry-component="Header" data-sentry-source-file="index.tsx">
      <Flex alignItems="center" minW={{
      base: '12.5rem',
      md: 'auto'
    }} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        <IfRender condition={pathname === '/'} data-sentry-element="IfRender" data-sentry-source-file="index.tsx">
          <Text size="xl" data-sentry-element="Text" data-sentry-source-file="index.tsx">{greetings}</Text>
        </IfRender>
        <IfRender condition={pathname !== '/' && !!title} data-sentry-element="IfRender" data-sentry-source-file="index.tsx">
          <Flex alignItems="center" gap="2xl" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
            <Text size="xl" data-sentry-element="Text" data-sentry-source-file="index.tsx">
              <IconButton aria-label="Voltar" data-testid="button-back" icon={<ChevronLeft color="content.primary" boxSize="1.5rem !important" />} variant="naked" onClick={handleNavigateBack} mb="2xs" data-sentry-element="IconButton" data-sentry-source-file="index.tsx" />
              {title}
            </Text>
            <IfRender condition={monetaryButtonHeaderScreensRoutes.includes(pathname)} data-sentry-element="IfRender" data-sentry-source-file="index.tsx">
              <MonetaryVisibilityButton h="1.5rem" mb="2xs" data-sentry-element="MonetaryVisibilityButton" data-sentry-source-file="index.tsx" />
            </IfRender>
            <IfRender condition={showLogo} data-sentry-element="IfRender" data-sentry-source-file="index.tsx">
              <Thumb src="/assets/eu_quero_investir.svg" width={50} height={34} fit="contain" alt="Logo eu quero investir texto por extenso" data-sentry-element="Thumb" data-sentry-source-file="index.tsx" />
            </IfRender>
          </Flex>
        </IfRender>
      </Flex>
      <Flex justifyContent="center" alignItems="center" gap="m" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        {rightChildren}
        <RightActions data-sentry-element="RightActions" data-sentry-source-file="index.tsx" />
      </Flex>
    </Flex>;
};
export type HeaderProps = {
  rightChildren?: ReactNode;
  showLogo?: boolean;
  title?: string;
};